export default [
    // {
    //     name: 'backgroundSound',
    //     type: 'audio',
    //     path: 'sounds/background.mp3'
    // },
    // {
    //     name: 'predatorModel',
    //     type: 'gltfModel',
    //     path: 'models/predator.glb'
    // },
    // {
    //     name: 'displacementTexture',
    //     type: 'texture',
    //     path: 'textures/displacement.jpg'
    // }

    {
        name: 'e2Model',
        type: 'gltfModel',
        path: 'models/水母.glb'
    },
    // {
    //     name: 'dnaModel',
    //     type: 'gltfModel',
    //     path: 'models/dna.glb'
    // },
    {
        name: 'boyModel',
        type: 'gltfModel',
        path: 'models/fox9_sub.glb'
    },
    {
        name: 'fox9Model',
        type: 'gltfModel',
        path: 'models/fox9_sub.glb'
    },
    {
        name: 'oniModel',
        type: 'gltfModel',
        path: 'models/死亡骑士.glb'
    },
    {
        name: 'horseModel',
        type: 'gltfModel',
        path: 'models/fenghuang_morph.glb'
    },
    {
        name: 'fishModel',
        type: 'gltfModel',
        path: 'models/fish.glb'
    },
    {
        name: 'treeModel',
        type: 'gltfModel',
        path: 'models/fairy2.glb'
    },
]
